import { makeRecord, objectKeys } from '@adflow/shared/util-js';
import {
	minPatchObject,
	minPatchPrimitive,
} from '@adflow/shared/util-superstruct';

import { EditUserDto } from './edit-user.dto';

export const minPatchEditUserDto = minPatchObject<EditUserDto>({
	...makeRecord(objectKeys(EditUserDto.schema), () => minPatchPrimitive),
});
